var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'v-box',
    _vm.boxDisplay,
    _vm.boxItemAlignment,
    _vm.boxContentJustifyAlignment,
    _vm.boxFlexDirections,
    _vm.boxFlexGaps
  ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }